


   <div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">Add customer</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>

    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Name</mat-label>
        <input [(ngModel)]="customerData.customer_name" matInput [disabled]="editmode" />
       
      </mat-form-field>
    </div>
    <!-- <div>
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Phone</mat-label>
          <input [(ngModel)]="customerData.customerPh" matInput  type="tel" smNumericOnly
          maxlength="10"/>
          
        </mat-form-field>
      </div> -->
    <div class="row g-2 justify-content-between phone-field">
      <mat-form-field appearance="outline" class="country-code col-3">
        <mat-label>Country Code</mat-label>
        <mat-select
        [disabled]="editmode"
        [(ngModel)]="selectedCountryCode"
        required
        (selectionChange)="onCountrySelected($event)"
      >
        <mat-select-trigger>
          {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
              {{ "(" + selectedCountryCode.dial_code + ")" }}
        </mat-select-trigger>
        
        <mat-option>
          <ngx-mat-select-search
            noEntriesFoundLabel="no results found"
            name="countrysearch"
            placeholderLabel="Enter country name"
            [formControl]="searchString"
            (keyup)="onKey()"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let country of countryList" [value]="country">
          {{ country.flag }} {{ country.name }}
          {{ "(" + country.dial_code + ")" }}
        </mat-option>
      </mat-select>
      </mat-form-field>
      <mat-form-field class="mobile_form col-9" appearance="outline">
        <mat-label>Phone</mat-label>
        <input
        [disabled]="editmode"
          [(ngModel)]="customerData.customer_phone"
          matInput
          type="tel"
          smNumericOnly
          minLength="3"
                  maxlength="17"
        />
        <mat-hint
          style="color: red; font-size: 13px"
          align="end"
          *ngIf="
            customerData.customer_phone &&
            customerData.customer_phone != '' &&
            customerData.customer_phone.length < 3
          "
          >Enter a valid phone number.</mat-hint
        >
      </mat-form-field>
    </div>
  
    <!-- <div class="radio_group">
      <label>Gender: </label>
      <mat-radio-group [(ngModel)]="customerData.gender">
        <mat-radio-button value="Male">Male</mat-radio-button>
        <mat-radio-button value="Female">Female</mat-radio-button>
        <mat-radio-button value="Others">Others</mat-radio-button>
      </mat-radio-group>
    </div>  -->
      <div class="radio_group">
    <mat-label>Gender: </mat-label>
    <br>
    <mat-radio-group [(ngModel)]="customerData.gender">
      <mat-radio-button [value]="1">Male</mat-radio-button>
      <mat-radio-button [value]="2">Female</mat-radio-button>
      <mat-radio-button [value]="3">Others</mat-radio-button>
    </mat-radio-group>
  </div>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Email</mat-label>
        <input matInput [(ngModel)]="customerData.email" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Payment due</mat-label>
        <input matInput  smDecimalOnly  type="number" [(ngModel)]="customerData.payment_due"/>
      </mat-form-field>
    </div>
   
    <div >
      <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker1.open()" style="padding: 0px;">
          <mat-label>Last booking date</mat-label>
          <input matInput [matDatepicker]="picker1" [(ngModel)]="customerData.last_booking_date" readonly >
  
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1 disabled="false"></mat-datepicker>
        </mat-form-field>
  </div>
    <div >
      <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker2.open()" style="padding: 0px;">
          <mat-label>DOB</mat-label>
          <input matInput [matDatepicker]="picker2" [(ngModel)]="customerData.dob" readonly >
  
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2 disabled="false"></mat-datepicker>
        </mat-form-field>
  </div>
 <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Notes</mat-label>
        <textarea [(ngModel)]="customerData.note"[maxLength]="400" matInput></textarea>
        <!-- <mat-icon matSuffix class="material-icons-outlined">message</mat-icon> -->
      </mat-form-field>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button
      mat-button
      mat-dialog-close
  
    >
      Cancel
    </button>
    <button
      
      mat-flat-button
      color="accent"
      [disabled]="!customerData.customer_phone || !customerData.customer_name || formChecker()"
      (click)="onPost()"
      
    >
    Confirm
    </button>

  </mat-dialog-actions>
  